import { DeleteAccountErrorKind } from '@griply/types';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './delete-account.style';

export type DeleteAccountErrorProps = {
  errorKind: DeleteAccountErrorKind;
  onRetry: () => void;
  onSignOut: () => void;
  onCancel: () => void;
};

export const DeleteAccountError: React.FC<DeleteAccountErrorProps> = ({
  errorKind,
  onRetry,
  onSignOut,
  onCancel,
}) => {
  const { t } = useTranslation();

  if (errorKind === DeleteAccountErrorKind.RequiresRecentLogin) {
    return (
      <>
        <Styled.Header>
          <Typography variant="h5" component="h1">
            {t('dialogs.delete-account.error.requires-recent-login.title')}
          </Typography>
        </Styled.Header>

        <Styled.Body>
          <Typography variant="body2">
            {t(
              'dialogs.delete-account.error.requires-recent-login.description',
            )}
          </Typography>
        </Styled.Body>

        <Styled.Interactions>
          <Button
            variant={Variants.Outlined}
            size={Sizes.Medium}
            color={Colors.Inherit}
            onClick={onCancel}
          >
            {t(
              'dialogs.delete-account.error.requires-recent-login.button.cancel',
            )}
          </Button>
          <Button size={Sizes.Medium} color={Colors.Error} onClick={onSignOut}>
            {t(
              'dialogs.delete-account.error.requires-recent-login.button.sign-out',
            )}
          </Button>
        </Styled.Interactions>
      </>
    );
  }

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t('dialogs.delete-account.error.title')}
        </Typography>
      </Styled.Header>

      <Styled.Body>
        <Typography variant="body2">
          {t('dialogs.delete-account.error.description')}
        </Typography>
      </Styled.Body>

      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          color={Colors.Inherit}
          onClick={onCancel}
        >
          {t('dialogs.delete-account.error.button.cancel')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onRetry}>
          {t('dialogs.delete-account.error.button.retry')}
        </Button>
      </Styled.Interactions>
    </>
  );
};
